const ResultMessageRefinementTaxonomy = 'Symptoms.id';

export { ResultMessageRefinementTaxonomy };
